import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface CalcSliceState {
	enabled: boolean
}

const initialState: CalcSliceState = {
	enabled: false,
}

const calcSlice = createSlice({
	name: 'calc',
	initialState,
	reducers: {
		setCalcEnabled(state, action: PayloadAction<boolean>) {
			state.enabled = action.payload
		}
	}
})

export const {
	setCalcEnabled
} = calcSlice.actions
export default calcSlice.reducer
